import { render, staticRenderFns } from "./signoff.vue?vue&type=template&id=15588928&scoped=true"
import script from "./signoff.vue?vue&type=script&lang=ts"
export * from "./signoff.vue?vue&type=script&lang=ts"
import style0 from "./signoff.vue?vue&type=style&index=0&id=15588928&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15588928",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15588928')) {
      api.createRecord('15588928', component.options)
    } else {
      api.reload('15588928', component.options)
    }
    module.hot.accept("./signoff.vue?vue&type=template&id=15588928&scoped=true", function () {
      api.rerender('15588928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dates/signoff.vue"
export default component.exports